import React from "react";
import "./NavbarClass.css";
import { Link } from "react-router-dom";
import { Navbar, Nav, NavDropdown, Button } from "react-bootstrap";
import { signOut } from "../actions/userActions";
import { connect } from "react-redux";
import { loggedInAndPremiumCheckUser } from "../actions/userActions";
import { openSignUpModal } from "../actions/generalActions";
import history from "../config/history";
class NavbarClass extends React.Component {
  state = {
    signModalShow: false,
    priceModalShow: false,
    loggedIn: false,
    userData: null,
    premium: false,
    yPosition: 0,
  };

  render() {
    const avatar = () => (
      <img
        alt="User Avatar Image"
        width="30px"
        src={`${process.env.REACT_APP_AWS_IMG_CDN}/others/user_avatar.png`}
        style={{ borderRadius: "100%" }}
      />
    );

    return (
      <Navbar
        className="nav-custom"
        style={
          this.props.homePageNavbar
            ? {}
            : { boxShadow: "0 0 10px 0 rgba(0,0,0,0.1)" }
        }
        collapseOnSelect
        expand="lg"
        sticky={!this.props.homePageNavbar && "top"}
        bg={this.props.homePageNavbar ? "transparent" : "light"}
        variant="light"
      >
        <Navbar.Brand
          className="navbar-brand-custom"
          onClick={() => history.push("/")}
        >
          {" "}
          <img
            alt="This is a logo with 'M' written in red colour. It has a beige colour waffle sitting upside down on the left top corner."
            src={`${process.env.REACT_APP_AWS_IMG_CDN}/logos/M_logo.webp`}
            style={{ width: "30px", marginBottom: "8px" }}
            width="45"
            height="47"
          />
        </Navbar.Brand>
        <Navbar.Toggle className="float-right" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto" navbarScroll>
            <Nav.Link
              className={
                history.location.pathname === "/videos" && "navbar-selected"
              }
              onClick={() => history.push("/videos")}
            >
              Videos
            </Nav.Link>
            <Nav.Link
              className={
                history.location.pathname === "/activities" && "navbar-selected"
              }
              onClick={() => history.push("/activities")}
            >
              Activities
            </Nav.Link>
            {!this.props.userStatus?.isPremium && (
              <Nav.Link
                className={
                  history.location.pathname === "/pricing" && "navbar-selected"
                }
                onClick={() => history.push("/pricing")}
              >
                Pricing
              </Nav.Link>
            )}
            <Nav.Link
              className={
                history.location.pathname === "/characters" && "navbar-selected"
              }
              onClick={() => history.push("/characters")}
            >
              Characters
            </Nav.Link>
            <Nav.Link
              className={
                history.location.pathname === "/books" && "navbar-selected"
              }
              onClick={() => history.push("/books")}
            >
              Books
            </Nav.Link>
            {this.props.userStatus?.isLoggedIn && (
              <Nav.Link
                className={
                  history.location.pathname === "/aboutus" &&
                  "navbar-selected-aboutus"
                }
                onClick={() => history.push("/aboutus")}
              >
                About Us
              </Nav.Link>
            )}
            {/* <Nav.Link
              className={
                history.location.pathname === "/blogs" && "navbar-selected"
              }
              onClick={() => history.push("/blogs")}
            >
              Blogs
            </Nav.Link> */}
          </Nav>
          <Nav>
            {!this.props.userStatus?.isPremium && (
              <Nav.Link>
                <Button
                  variant=""
                  className="ds-btn-secondary nav-btn-subscribe"
                  onClick={() => history.push("/pricing")}
                >
                  Subscribe
                </Button>
              </Nav.Link>
            )}
            {this.props.userStatus?.isLoggedIn ? (
              <NavDropdown
                alignRight
                title={avatar()}
                id="collasible-nav-dropdown"
              >
                <NavDropdown.Item onClick={() => history.push("/settings")}>
                  My Account
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={this.props.signOut}>
                  Log Out
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Link>
                <Button
                  variant=""
                  className="ds-btn-primary nav-btn-login"
                  onClick={this.props.openSignUpModal}
                >
                  Login
                </Button>
              </Nav.Link>
            )}
          </Nav>
          {/* <SignIn
            signModalShow={this.state.signModalShow}
            handleSignInClose={this.handleSignInClose}
          /> */}
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userStatus: state.userLoggedinAndPremiumCheck,
  };
};
export default connect(mapStateToProps, {
  signOut,
  openSignUpModal,
  loggedInAndPremiumCheckUser,
})(NavbarClass);
